<template>
  <div class="row pt-3">
    <div class="col">
      <div class="alert alert-danger p-2 mx-3"><span v-if="errorNumber" class="badge text-bg-danger">{{ errorNumber }}</span> {{ alertMessage }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'erroralert',
  props: {
    alertMessage: "",
    errorNumber: 0,
  }
}
</script>